import colorContrast from 'color-contrast';

export const isDark = (background) => {
  return colorContrast(background, '#111') < 10 ? true : false; 
}